import Axios from 'axios'

export const getAccessToken = () => {
  const key = Object.keys(window.sessionStorage).filter(
    p => p.indexOf('oidc.user') > -1
  )[0]
  const userInfo = window.sessionStorage.getItem(key)
  const parsed = JSON.parse(userInfo)
  return parsed ? parsed.access_token : ''
}

export const getParticipantInfo = () => {
  const key = Object.keys(window.sessionStorage).filter(
    p => p.indexOf('oidc.user') > -1
  )[0]
  const userInfo = window.sessionStorage.getItem(key)
  const parsed = JSON.parse(userInfo)
  return parsed ? parsed.profile : ''
}

const getCampaignId = () => {
  var infos = getParticipantInfo()
  return infos['custom:campaign_id']
}

const getCatalogId = () => {
  var infos = getParticipantInfo()
  return infos['custom:catalog_id']
}

export const getLogin = () => {
  var infos = getParticipantInfo()
  return infos.username
}

const axios = Axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    'Authorization': `Bearer ${getAccessToken()}`,
    'campaignId': `${getCampaignId()}`,
    'catalogId': `${getCatalogId()}`
  },
  baseURL: process.env.REACT_APP_FOCAL_POINT_API
})

export const axiosPremmiar = Axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    'Authorization': `Bearer ${getAccessToken()}`,
    'login': `${getLogin()}`
  },
  baseURL: process.env.REACT_APP_PREMMIAR_ADMIN_ENDPOINT
})

export default axios



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Shared/axios.js